/**
 * Google reviews carousel
 */
(function () {
  'use strict';

  var AUTO_MS = 6000;

  function getVisibleCount(root) {
    if (window.matchMedia('(min-width: 990px)').matches) {
      var slides = parseInt(getComputedStyle(root).getPropertyValue('--mm-greviews-slides'), 10);
      return slides > 0 ? slides : 3;
    }
    if (window.matchMedia('(min-width: 750px)').matches) return 2;
    return 1;
  }

  function initCarousel(root) {
    var viewport = root.querySelector('[data-greviews-viewport]');
    var track = root.querySelector('[data-greviews-track]');
    var prev = root.querySelector('[data-greviews-prev]');
    var next = root.querySelector('[data-greviews-next]');
    var dotsWrap = root.querySelector('[data-greviews-dots]');
    if (!viewport || !track || !track.children.length) return;

    var cards = Array.prototype.slice.call(track.children);
    var index = 0;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function visible() {
      return getVisibleCount(root);
    }

    function maxIndex() {
      return Math.max(0, cards.length - visible());
    }

    function updateDots() {
      if (!dotsWrap) return;
      var pages = maxIndex() + 1;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mm-greviews__dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to review page ' + (i + 1));
        dot.dataset.page = String(i);
        dotsWrap.appendChild(dot);
      }
    }

    function slideWidth() {
      var card = cards[0];
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    function goTo(i, animate) {
      index = Math.max(0, Math.min(i, maxIndex()));
      var offset = index * slideWidth();
      if (reduced || animate === false) {
        track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      } else {
        track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      }
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= maxIndex();
      updateDots();
    }

    function nextSlide() {
      goTo(index >= maxIndex() ? 0 : index + 1, true);
    }

    function prevSlide() {
      goTo(index <= 0 ? maxIndex() : index - 1, true);
    }

    function startAuto() {
      if (reduced || maxIndex() === 0) return;
      stopAuto();
      timer = window.setInterval(nextSlide, AUTO_MS);
    }

    function stopAuto() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) prev.addEventListener('click', function () { prevSlide(); startAuto(); });
    if (next) next.addEventListener('click', function () { nextSlide(); startAuto(); });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-page]');
        if (!btn) return;
        goTo(parseInt(btn.dataset.page, 10), true);
        startAuto();
      });
    }

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', startAuto);

    window.addEventListener('resize', function () {
      goTo(Math.min(index, maxIndex()), false);
    });

    track.style.transition = reduced ? 'none' : 'transform 0.55s cubic-bezier(0.16, 1, 0.3, 1)';
    root.setAttribute('data-greviews-ready', '');
    goTo(0, false);
    startAuto();
  }

  function boot() {
    document.querySelectorAll('[data-greviews-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
